export enum APP_KEY {
	NEXT_GEN = "nextgen",
	CLASSIC = "classic",
	ADMIN = "admin",
	SUPERADMIN = "superadmin",
	PLAYPOSIT = " playposit",
}

export const DARK_NEUTRALS = {
	N000: "#FFFFFF",
	N004: "hsla(0, 0%, 60%, 1)",
	N006: "rgba(255, 255, 255, 0.06)",
	N010: "hsla(0, 0%, 100%, 0.1)",
	N022: "rgba(255,255,255,0.22)",
	N025: "rgba(255,255,255,0.25)",
	N050: "#F9F9F9",
	N100: "#CCCCCC",
	N105: "#C4C4C4",
	N200: "#A3A3A3",
	N300: "#8D8D8D",
	N310: "#D8D8D8",
	N400: "#424242",
	N500: "#363636",
	N550: "#4F4F4F",
	N600: "#2B2B2B",
	N650: "#262626",
	N700: "#212121",
	N750: "#161616",
	N800: "#000000",
	N820: "rgba(0, 0, 0, 0.2)",
	N1000: "#000000",
	N1006: "rgba(0, 0, 0, 0.6)",

	BRAND: {
		PRIMARY: "#267B8A",
		SECONDARY: "#2CAFC0",
		TINT100: "#61C1CE",
		TINT150: "rgba(97, 193, 206, 0.5)",
		TINT200: "#79D1FC",
		TINT250: "rgba(121, 209, 252, 0.7)",
		SHADE100: "#F9FDFF",
		SHADE200: "#218A9A",
		SHADE250: "#1A6F7B",
	},
	GREEN: {
		PRIMARY: "#008731",
		TINT100: "#00B341",
		SHADE100: "#00782C",
		SHADE200: "#1B502E",
	},
	RED: {
		PRIMARY: "#F67A91",
		TINT100: "#DF0C39",
	},
	YELLOW: {
		PRIMARY: "#F2BE00",
		TINT100: "#F5CE40",
		TINT200: "#fcf2d6",
	},
	GRAY: {
		TINT50: "#E8E8E8",
		TINT250: "#8D8D8D",
		TINT300: "#868686",
		TINT400: "#404040",
		TINT500: "#3B3B3B",
		TINT550: "#4F4F4F",
		TINT625: "#545454",
		DARK: "#646464",
	},
	PURPLE: {
		PRIMARY: "#5F67C2",
		TINT100: "#BE95FF",
	},
	TEMPORARY: {
		CLASSROOM_BLUE: "#28A2B5",
		CLASSIC_GRAY: "#707070",
		ADMIN_YELLOW: "#B68854",
		PLAYPOSIT_BLUE: "#4696EC",
	},
};

export const LIGHT_NEUTRALS = {
	N000: "#FFFFFF",
	N050: "#F9F9F9",
	N065: "hsla(0, 0%, 100%, 0.65)",
	N004: "hsla(0, 0%, 60%, 1)",
	N100: "#FAFAFA",
	N200: "#F0F0F0",
	N300: "#DBDBDB",
	N310: "#D8D8D8",
	N400: "#999999",
	N500: "#737373",
	N600: "#575757",
	N700: "#161616",
	N900: "#2B2B2B",
	N1000: "#000000",
	N1100: "#666666",
	N1175: "hsla(0, 0%, 40%, 0.25)",
	N2000: "hsla(0, 0%, 60%, 1)",
	N1006: "rgba(0, 0, 0, 0.6)",

	BRAND: {
		PRIMARY: "#267B8A",
		SECONDARY: "#2CAFC0",
		TINT100: "#61C1CE",
		TINT200: "#79D1FC",
		TINT250: "rgba(121, 209, 252, 0.7)",
		SHADE100: "#F9FDFF",
		SHADE200: "#218A9A",
		SHADE250: "#1A6F7B",
	},
	GREEN: {
		PRIMARY: "#008731",
		TINT50: "#88EBAC",
		TINT100: "#00B341",
		SHADE100: "#00782C",
		TS: "#F9FDFF",
	},
	RED: {
		PRIMARY: "#B00020",
		TINT100: "#DF0C39",
	},
	YELLOW: {
		PRIMARY: "#F2BE00",
		TINT100: "#F5CE40",
		TINT200: "#fcf2d6",
	},
	GRAY: {
		TINT50: "#E8E8E8",
		TINT250: "#8D8D8D",
		TINT300: "#868686",
		TINT400: "#404040",
		TINT500: "#3B3B3B",
		TINT550: "#4F4F4F",
		TINT600: "#444444",
		TINT625: "#545454",
		TINT650: "#555555",
		DARK: "#646464",
	},
	PURPLE: {
		PRIMARY: "#5F67C2",
		TINT100: "#8A3FFC",
	},
	TEMPORARY: {
		CLASSROOM_BLUE: "#F5FCFF",
		CLASSIC_GRAY: "#EBEEF0",
		ADMIN_YELLOW: "#FFEDD8",
		PLAYPOSIT_BLUE: "#DAEAFB",
	},
};

export const TYPERAMP = {
	B1_TITLE: {
		fontFamily: "Lato, lato",
		fontSize: "32px",
		lineHeight: "64px",
		fontWeight: 700,
		letterSpacing: "0.02em",
	},
	B2_HEADING: {
		fontFamily: "Lato, lato",
		fontSize: "21px",
		lineHeight: "32px",
		fontWeight: 700,
		letterSpacing: "0.02em",
	},
	// B3 Subhead
	B3_SUBHEAD: {
		fontFamily: "Lato, lato",
		fontSize: "18px",
		lineHeight: "24px",
		fontWeight: 500,
		letterSpacing: "0.02em",
	},
	B4_BODY: {
		fontFamily: "Lato, lato",
		fontSize: "16px",
		lineHeight: "22px",
		fontWeight: 400,
		letterSpacing: "0.02em",
	},
	B4_BODY_BOLD: {
		fontFamily: "Lato, lato",
		fontSize: "16px",
		lineHeight: "22px",
		fontWeight: 700,
		letterSpacing: "0.02em",
	},
	B5_CAPTION: {
		fontFamily: "Lato, lato",
		fontSize: "13px",
		lineHeight: "18px",
		fontWeight: 500,
		letterSpacing: "0.02em",
	},
	B6_MICRO: {
		fontFamily: "Lato, lato",
		fontSize: "11px",
		lineHeight: "12px",
		fontWeight: 500,
		letterSpacing: "0.02em",
	},
	B6_CAPTION_BOLD: {
		fontFamily: "Lato, lato",
		fontSize: "13px",
		lineHeight: "18px",
		fontWeight: 700,
		letterSpacing: "0.02em",
	},
	B6_CAPTION: {
		fontFamily: "Lato, lato",
		fontSize: "12px",
		lineHeight: "16px",
		fontWeight: 400,
		letterSpacing: "0.02em",
	},
};

export const INPUT_LENGTH = {
	xs: 256,
	sm: 512,
	md: 1024,
	lg: 2048,
	xl: 4096,
	xxl: 10000,
} as const;

export const DEFAULT_SPACING = 8;
export const DEFAULT_BORDER_RADIUS = 4;

export const VIDEO_PLAYER_MAX_WIDTH = 1280;
export const VIDEO_PLAYER_MAX_HEIGHT = 720;

export const DEFAULT_CUE = {
	line: 90,
	align: "center" as AlignSetting,
	size: 100,
	position: 0,
};
